<template>
  <div class="editPatient">
    <div class="w3-padding">
      <patient-card v-bind:patientData="getPatientById(patient_id)"/>
    </div>
    <edit-patient v-bind:patientData="getPatientById(patient_id)"/>
    {{getPatientById(patient_id)}}
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import EditPatientVue from "../components/EditPatient.vue";
import PatientCardVue from '../components/PatientCard.vue';
export default {
  name: "EditPatient",
  props: ["patient_id"],
  components: {
    "edit-patient": EditPatientVue,
    "patient-card": PatientCardVue
  },
  computed: {
    ...mapGetters({getPatientById:'findPatientById'})
  }
};
</script>

<style>
</style>

